const numericDataTypes = ['Decimal', 'Integer'];
export function isNumeric(dataType: string) {
  return numericDataTypes.includes(dataType);
}

export interface StatsDto {
  dimensions: ValueDefDto[];
  measures: ValueDefDto[];
  group: { dimensions: ValueDefDto[]; aggregations: AggregateValuesDto[] };
}

export interface ValueDefDto {
  name: string;
  displayName: string;
  dataType: string;
  index: number;
}

export interface AggregateValuesDto {
  totals: RowDataDto;
  data: RowDataDto[];
}

export interface RowDataDto {
  dimensionKeys: (string | null)[];
  measureValues: (number | null)[];
}
